/**
 * Homeowner Projects page. A connected sponsor keeps the original wording.
 * A homeowner with no sponsor sees neutral copy.
 */

const CONNECTED_INTRO = 'Your sponsor has created these project checklists for you to complete.';
const DETACHED_INTRO = 'These project checklists are saved with your home.';
const CONNECTED_EMPTY = 'Your sponsor will create project checklists here when you have larger maintenance or improvement tasks to complete.';
const DETACHED_EMPTY = 'Project checklists for larger maintenance or improvement tasks will show up here.';

function projectChecklistCopy(hasAgent, options) {
  const ownProject = Boolean(options && options.ownProject);
  if (ownProject) {
    return {
      intro: DETACHED_INTRO,
      empty: hasAgent ? CONNECTED_EMPTY : DETACHED_EMPTY,
    };
  }
  if (hasAgent) return { intro: CONNECTED_INTRO, empty: CONNECTED_EMPTY };
  return { intro: DETACHED_INTRO, empty: DETACHED_EMPTY };
}

export {
  CONNECTED_INTRO,
  DETACHED_INTRO,
  CONNECTED_EMPTY,
  DETACHED_EMPTY,
  projectChecklistCopy,
};
